// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"441":"0f4cbfdf","853":"fa15c12d"}[chunkId] + ".css";
};